export * from './sidebar';



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/index.ts